module.exports = __webpack_public_path__ + "img/trashHover.3277cb84.svg";